export default "__VITE_ASSET__de80bbb7__"